import { apiClient } from '../../../shared/api/apiClient';

const CAMPAIGN_CADENCES_PATH = '/campaign-cadences/marketing/';
const CAMPAIGN_CADENCE_TRIGGERS_PATH = '/message-templates/trigger-campaign-cadences/';

export function fetchCampaignCadence({ campaignId, channel }) {
  const params = new URLSearchParams({
    campaign_id: String(campaignId),
    channel,
  });
  return apiClient.get(`${CAMPAIGN_CADENCES_PATH}?${params}`);
}

export function fetchCampaignCadenceTriggers({ channels }) {
  const params = new URLSearchParams();
  const list = Array.isArray(channels) ? channels : [channels];
  for (const value of list) {
    if (value) params.append('channel', String(value));
  }
  return apiClient.get(`${CAMPAIGN_CADENCE_TRIGGERS_PATH}?${params}`);
}

// `steps` is one list of template ids per step; the API allows one template per language in each.
export function patchCampaignCadenceOrder({ campaignCadenceId, steps }) {
  return apiClient.patchJson(`${CAMPAIGN_CADENCES_PATH}${campaignCadenceId}/order/`, { steps });
}
